import { render } from "./lessonPeopleNumEchart.vue?vue&type=template&id=81d1d16c&scoped=true"
import script from "./lessonPeopleNumEchart.vue?vue&type=script&lang=js"
export * from "./lessonPeopleNumEchart.vue?vue&type=script&lang=js"

import "./lessonPeopleNumEchart.vue?vue&type=style&index=0&id=81d1d16c&scoped=true&lang=scss"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81d1d16c"]])

export default __exports__